import React, { Component, Fragment } from 'react';

import { DocumentFieldText } from 'components/cards/document/preview/DocumentFieldText';
import { DefinitionField } from 'components/common/fields/DefinitionField';
import FieldsGroup from 'components/cards/document/fields/FieldsGroup';
import { strToDate } from 'mappers/commonMapper';
import { getValue, xmlArrayToObj, checkGroup } from 'helpers/documentsHelpers';
import { cardEdited } from '../fields/CardEdited';

const getclientEmployeeName = (clientEmployeeName, clientEmployeePost) => (
    `${clientEmployeeName}${clientEmployeePost ? ` - ${clientEmployeePost}` : ''}`
)

class Marketing extends Component {
    header = checkGroup(({
        marketingDate,
        marketingTarget,
        employeeName,
        selfParticipants,
        clientCompany,
        clientCategory,
        marketingInfoSource,
        clientEmployeeName,
        clientParticipants,
        eventResult,
    }) => (
        <FieldsGroup translate='marketing'>
            <DefinitionField translate="xml.OrgMrktCallData.DATE" show={!!marketingDate}>
                <DocumentFieldText
                    name="xml.OrgMrktCallData.DATE"
                    value={marketingDate}
                />
            </DefinitionField>
            <DefinitionField translate="xml.OrgMrktCallData.TARGET" show={!!marketingTarget}>
                <DocumentFieldText
                    name="xml.OrgMrktCallData.TARGET"
                    value={marketingTarget}
                />
            </DefinitionField>
            <DefinitionField translate="xml.OrgMrktCallData.SOTRNAME" show={!!employeeName}>
                <DocumentFieldText
                    name="xml.OrgMrktCallData.SOTRNAME"
                    value={employeeName}
                />
            </DefinitionField>
            <DefinitionField translate="xml.OrgMrktCallData.ADDANCORSOTR" show={!!selfParticipants}>
                <DocumentFieldText
                    name="xml.OrgMrktCallData.ADDANCORSOTR"
                    value={selfParticipants}
                />
            </DefinitionField>
            <DefinitionField translate="xml.OrgMrktCallData.ORGNAME" show={!!clientCompany}>
                <DocumentFieldText
                    name="xml.OrgMrktCallData.ORGNAME"
                    value={clientCompany}
                />
            </DefinitionField>
            <DefinitionField translate='xml.OrgMrktCallData.ORGKATEGOR' show={!!clientCategory}>
                <DocumentFieldText
                    name="xml.OrgMrktCallData.ORGKATEGOR"
                    value={clientCategory}
                />
            </DefinitionField>
            <DefinitionField translate="xml.OrgMrktCallData.INFABOUT" show={!!marketingInfoSource}>
                <DocumentFieldText
                    name="xml.OrgMrktCallData.INFABOUT"
                    value={marketingInfoSource}
                />
            </DefinitionField>
            <DefinitionField translate="xml.OrgMrktCallData.PPLNAME" show={!!clientEmployeeName}>
                <DocumentFieldText
                    name="xml.OrgMrktCallData.PPLNAME"
                    value={clientEmployeeName}
                />
            </DefinitionField>
            <DefinitionField translate="xml.OrgMrktCallData.ADDZAKSOTR" show={!!clientParticipants}>
                <DocumentFieldText
                    name="xml.OrgMrktCallData.ADDZAKSOTR"
                    value={clientParticipants}
                />
            </DefinitionField>
            <DefinitionField translate="xml.OrgMrktCallData.RESULT" show={!!eventResult}>
                <DocumentFieldText
                    name="xml.OrgMrktCallData.RESULT"
                    value={eventResult}
                />
            </DefinitionField>
        </FieldsGroup>
    ))

    conversationСontent = checkGroup(({ conversationСontent }) => (
        <FieldsGroup translate='conversationСontent'>
            <DocumentFieldText
                name="xml.OrgMrktCallData.ABOUTSPEAK"
                value={conversationСontent}
            />
        </FieldsGroup>
    ))

    interlocutorImpression = checkGroup(({ interlocutorImpression }) => (
        <FieldsGroup translate='interlocutorImpression'>
            <DocumentFieldText
                name="xml.OrgMrktCallData.SIGN"
                value={interlocutorImpression}
            />
        </FieldsGroup>
    ))

    nextContact = checkGroup(({ nextContactDate, nextContactType, nextContactResponsible, comment }) => (
        <FieldsGroup translate='nextContact'>
            <DefinitionField translate="xml.OrgMrktCallData.NEXTDATE" show={!!nextContactDate}>
                <DocumentFieldText
                    name="xml.OrgMrktCallData.NEXTDATE"
                    value={nextContactDate}
                />
            </DefinitionField>
            <DefinitionField translate="xml.OrgMrktCallData.NEXTCNTTYPEST" show={!!nextContactType}>
                <DocumentFieldText
                    name="xml.OrgMrktCallData.NEXTCNTTYPEST"
                    value={nextContactType}
                />
            </DefinitionField>
            <DefinitionField translate="xml.OrgMrktCallData.NEXTCNT_SOTRNAME" show={!!nextContactResponsible}>
                <DocumentFieldText
                    name="xml.OrgMrktCallData.NEXTCNT_SOTRNAME"
                    value={nextContactResponsible}
                />
            </DefinitionField>
            <DefinitionField translate="xml.OrgMrktCallData.TARGETDESCR" show={!!comment}>
                <DocumentFieldText
                    name="xml.OrgMrktCallData.TARGETDESCR"
                    value={comment}
                />
            </DefinitionField>
        </FieldsGroup>
    ))

    render() {
        const { xml } = this.props;
        const xmlObject = xmlArrayToObj(xml);

        return (
            <Fragment>
                {this.header({
                    marketingDate: strToDate(getValue(xmlObject.DATE)),
                    marketingTarget: getValue(xmlObject.TARGET),
                    employeeName: getValue(xmlObject.SOTRNAME),
                    selfParticipants: getValue(xmlObject.ADDANCORSOTR),
                    clientCompany: getValue(xmlObject.ORGNAME),
                    clientCategory: getValue(xmlObject.ORGKATEGOR),
                    marketingInfoSource: getValue(xmlObject.INFABOUT),
                    clientEmployeeName: getclientEmployeeName(getValue(xmlObject.PPLNAME), getValue(xmlObject.PPLDOLG)),
                    clientParticipants: getValue(xmlObject.ADDZAKSOTR),
                    eventResult: getValue(xmlObject.RESULT),
                })}
                { this.conversationСontent({
                    conversationСontent: getValue(xmlObject.ABOUTSPEAK)
                })}
                { this.interlocutorImpression({
                    interlocutorImpression: getValue(xmlObject.SIGN)
                })}
                { this.nextContact({
                    nextContactDate: strToDate(getValue(xmlObject.NEXTDATE)),
                    nextContactType: getValue(xmlObject.NEXTCNTTYPEST),
                    nextContactResponsible: getValue(xmlObject.NEXTCNT_SOTRNAME),
                    comment: getValue(xmlObject.TARGETDESCR),
                })}
                { cardEdited({
                    documentUpdateDate: strToDate(getValue(xmlObject.whenchange)),
                    documentUpdatePerson: getValue(xmlObject.whochange),
                    documentLettersUpdate: getValue(xmlObject.howmanylettersadded),
                })}

            </Fragment>
        );
    }
}

export default Marketing;
